module.exports = __webpack_public_path__ + "media/c2.d85cbb5e.mp3";